import React from "react";
import { useParams } from "react-router-dom";
import KnowledgeTable from "../../../features/ai/llm-rag/components/table/KnowledgeTable";

function BrainPage({}) {
    const { brainId } = useParams();
    return <KnowledgeTable brainId={brainId} />;
}

export default BrainPage;
